export enum IntegrationSuccessRedirectPage {
    Workflow = 'workflow',
    Company = 'company',
}
